@if (client?.kycState; as kycState) {
  @let style = STYLE_MAP[kycState.name];
  @let stateKey = kycState.name;
  @let canToggle =
    stateKey === KycStates.VALID || stateKey === KycStates.INVALID;

  @if (compactView) {
    <span layout="row" layout-align="start center">
      <div
        [matTooltip]="'verification.kycState.tooltip.' + stateKey | translate"
        matTooltipPosition="above"
        class="icon-button-container"
      >
        <button
          mat-icon-button
          [disabled]="!canToggle"
          (click)="toggleKycState()"
        >
          <mat-icon
            fontSet="material-symbols-outlined"
            class="fill"
            [ngStyle]="{ color: style?.backgroundColor }"
          >
            {{ style?.icon }}
          </mat-icon>
        </button>
      </div>

      @if (displayLabel) {
        <span>{{ 'verification.kycState.short.' + stateKey | translate }}</span>
      }
    </span>
  } @else {
    <div
      [matTooltip]="'verification.kycState.tooltip.' + stateKey | translate"
      matTooltipPosition="below"
    >
      <button
        type="button"
        class="verification-status"
        mat-stroked-button
        [disabled]="!canToggle"
        (click)="toggleKycState()"
      >
        <div layout="row" layout-align="space-between center">
          <mat-icon
            matChipAvatar
            fontSet="material-symbols-outlined"
            class="fill"
            [ngStyle]="{ color: style?.backgroundColor }"
          >
            {{ style?.icon }}
          </mat-icon>
          {{ 'verification.kycState.short.' + stateKey | translate }}
        </div>
      </button>
    </div>
  }
}
